import { Dropdown } from "primereact/dropdown";
import { itemTemplate, valueTemplate } from "@components";
import { LocationDropdownProps } from "./types";

export function LocationDropdown({
  value,
  options,
  onChange,
  icon,
  className = "md:w-20rem w-full",
  placeholder,
}: LocationDropdownProps) {
  return (
    <Dropdown
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder || "Select an option"}
      filter
      showClear
      itemTemplate={(option) => itemTemplate(option, icon)}
      valueTemplate={(option) => valueTemplate(option, icon)}
      className={className}
    />
  );
}
